module.exports = __webpack_public_path__ + "static/img/sync_success.faa2c1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sync_success.png
// module id = MwtR
// module chunks = 1